export default __webpack_public_path__ + "static/media/flag-uzbekistan.62cbf352.svg";